import moment from 'moment';
const weekdays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export function groupByListData(data: Array<any>, formatMessage: any) {
  const result: any = {};
  data.forEach(item => {
    const timeKey = moment(item.trends_date);
    const key = timeKey.format('YYYY-MM-DD');
    if (!result[key]) {
      const day = timeKey.day();
      result[key] = {
        list: [],
        time: `${key} ${formatMessage({ id: weekdays[day] })}`,
      };
    }

    result[key].list.push(item);
  });

  return result;
}

export function dealwithChartsData(
  data: Array<any>,
  todayKey: string,
  otherDayKey: string,
  xAxisFn: (value: any, num: number) => string,
) {
  const xAxis: Array<any> = [];
  const toDaySeries: Array<any> = [];
  const otherDaySeries: Array<any> = [];

  if (Array.isArray(data)) {
    data.forEach((item, index) => {
      toDaySeries.push(item[todayKey]);
      otherDaySeries.push(item[otherDayKey]);
      xAxis.push(xAxisFn(item, index));
    });
  }

  return { xAxis, toDaySeries, otherDaySeries };
}

/**
 * 处理字符串unicode字符串
 * @param str
 */
export function dealwithStr(str: string) {
  try {
    return str.replace(/\&#.*?\;/g, function (match) {
      let code = match.replaceAll(/&#|;/g, '');
      return String.fromCharCode(Number(code));
    });
  } catch (error) {
    return str;
  }
}

// 定顺序 中 > 英 > 原
let languageSort: any = {
  zh: 1,
  en: 2,
  origin: 3,
};
// 定顺序 原 > 中 > 英
let titleLanguageSort: any = {
  zh: 2,
  en: 3,
  origin: 1,
};
export function getLanguageText(obj: any, languages: Array<string>) {
  const localLanguages = [...languages];
  localLanguages.sort((a, b) => languageSort[a] - languageSort[b]);
  const lKey = localLanguages[0];

  return (keyMap: { [key: string]: string }, backList: boolean = false) => {
    // 返回列表的话就这么返回
    if (backList) {
      let newLanguage = [...languages];
      newLanguage.sort((a, b) => titleLanguageSort[a] - titleLanguageSort[b]);
      return newLanguage.map(key => obj[keyMap[key]]).filter(Boolean);
    }

    return obj[keyMap[lKey]] || obj[keyMap['origin']];
  };
}
